import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, userType }) => {
  const token = localStorage.getItem('token');
  const userDataString = localStorage.getItem('userData');

  // Check if both token and userData exist
  if (!token || !userDataString) {
    return <Navigate to="/login" replace />;
  }

  // Parse userData to get role
  let userData;
  let role;
  
  try {
    userData = JSON.parse(userDataString);
    // Extract role from userData (can be in user_details.role or directly in role)
    role = userData?.user_details?.role || userData?.role || localStorage.getItem('role');
    
    // Convert role to number if it's a string
    if (role !== undefined && role !== null) {
      role = typeof role === 'string' ? parseInt(role, 10) : role;
    }
  } catch (error) {
    console.error('Error parsing userData:', error);
    return <Navigate to="/login" replace />;
  }

  // Map role numbers to user types: 1 = landlord, 2 = tenant
  const roleToUserType = {
    1: 'landlord',
    2: 'tenant'
  };

  const currentUserType = roleToUserType[role];

  // If userType is specified, check if it matches the current user's role
  if (userType && currentUserType !== userType) {
    // Redirect to appropriate dashboard based on user type
    if (currentUserType === 'tenant') {
      return <Navigate to="/tenant/dashboard" replace />;
    } else if (currentUserType === 'landlord') {
      return <Navigate to="/landlord/dashboard" replace />;
    }
    // If role doesn't match expected types, redirect to login
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
